import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Carousel, Spinner } from "react-bootstrap";
import PsContext from "../../../context";
import { ServiceUrl } from "../../../utils/serviceUrl";
import SliderImage from "./sliderImage";
import { DB_POSTFIX } from "../../../utils";
const HomeSlider = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    loadSliders();
  }, []);

  const field = (fieldName) => props?.dataSource?.[fieldName];

  const loadSliders = () => {
    setLoader(true);
    const limit = field("maxSliders") || 10;
    axios
      .get(ServiceUrl.LIST_SLIDERS + "?sadb=" + DB_POSTFIX + "&limit=" + limit)
      .then((res) => {
        if (res["data"].status == "1") {
          setSliders(res["data"].data);
          setLoader(false);
        }
      });
  };

  return (
    <>
      {sliders && sliders.length < 1 && (
        <div style={{ height: "calc(100vh - 250px" }}>
          <center className="">
            <Spinner animation="border" role="status"></Spinner>
          </center>
        </div>
      )}
      {sliders && sliders.length > 0 && (
        <div className="ps__home__slider">
          <Carousel>
            {sliders.map((item, i) => {
              return (
                <Carousel.Item className="">
                  <SliderImage item={item} />
                  {/*<Carousel.Caption>
                    <h3>First slide label</h3>
                    <p>
                      Nulla vitae elit libero, a pharetra augue mollis interdum.
                    </p>
                  </Carousel.Caption>*/}
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>
      )}
    </>
  );
};

export default HomeSlider;
